import ContentManager from 'src/componentes/content-manager';
import ErrorMessage from 'src/componentes/ErrorMessage';
import { EXCEPTION_CANCELLATION_TOKEN } from 'src/utils/constants';

export default function handleError(error) {
  if (error && error.message === EXCEPTION_CANCELLATION_TOKEN) return;
  ContentManager.addContent(<ErrorMessage error={error} />);
}
